module.exports = "fiscal information coming herer//"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/solutions/fiscal/fiscal.component.html
 ** module id = 100
 ** module chunks = 0
 **/